import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import swal from 'sweetalert2';

import './Directory.css';
import { getPositions } from '../../ducks/reducer';

class Directory extends Component {
  state = {
    state: '',
    current: '',
    all: [],
    nav: [
      { tag: 'h4', name: 'Name' },
      { tag: 'p', name: 'Department' },
      { tag: 'p', name: 'ISD' },
      { tag: 'p', name: 'School' },
      { tag: 'p', name: 'Email' }
    ],
    depart: ['Band', 'Choir', 'Orchestra', 'Mariachi'],
    directory: false,
    requests: true
  };

  componentDidMount() {
    this.props.getPositions();
    this.getDirectory();
  }

  getDirectory() {
    axios.get('/api/get-directory').then(res => {
      this.setState({ all: res.data });
    });
  }

  handleDepartment = async (e) => {
    await axios.get(`/api/get-directory?department=${e}`).then(res => {
      this.setState({ all: res.data }, () => this.setState({current: e}));
    });
    
  };

  handleDelete = e => {
    axios.delete(`/api/delete-position/${e.id}`).then(() => {
      this.props.getPositions();
    });
  };

  handleAdd = e => {
    axios.post(`/api/add-director/${e.id}`).then(() => {
      this.props.getPositions();
      this.getDirectory();
    });
  };

  handleDelete2 = async e => {
    await swal({
      position: 'top-end',
      type: 'warning',
      title: `Removing ${e.first_name} from the directory is permanent.`,
      text: 'Do you wish to continue?',
      confirmButtonText: 'Yes, remove them!',
      showCancelButton: true
    }).then(res => {
      if (res.value) {
        swal({
          position: 'top-end',
          type: 'success',
          title: `${e.first_name} has been removed from the directory.`,
          showConfirmButton: false,
          timer: 1000
        });
        axios.delete(`/api/delete-director/${e.director_id}`);
      } else if (res.dismiss === swal.DismissReason.cancel) {
        swal({
          position: 'top-end',
          type: 'error',
          title: 'Cancelled',
          text: `${e.first_name} is still here :)`,
          showConfirmButton: false,
          timer: 1000
        });
      }
    });

    await this.getDirectory();
    await this.handleDepartment(this.state.current)
  };

  directorMap = val => {
    return val.map(e => {
      return (
        <div className="director_incoming" key={e.id}>
          <h4>
            {e.first_name} {e.last_name}
          </h4>

          <p>{e.department}</p>
          <p>{e.isd}</p>
          <p>{e.school}</p>
          <p>{e.email}</p>
          <div className="dir_delete">
            {val === this.props.positions ? (
              <Fragment>
                <p onClick={() => this.handleDelete(e)}>Delete</p>
                <p onClick={() => this.handleAdd(e)}>Accept</p>
              </Fragment>
            ) : (
              <p onClick={() => this.handleDelete2(e)}>Delete</p>
            )}
          </div>
        </div>
      );
    });
  };

  navMap = () => {
    return this.state.nav.map((e, i) => {
      return React.createElement(e.tag, { key:i }, e.name);
    });
  };

  departMap = () => {
    const {depart, current} = this.state
    return depart.map((e,i) => {
      return React.createElement('p', {className:current === e ? 'highlight' : null, onClick:() => this.handleDepartment(e), key:i}, e)
    })
  }

  render() {
    const { positions } = this.props;
    const { directory, requests, all } = this.state;

    return (
      <div className="directory_container">
        <div className="dir_nav">
          <h4
            className={
              requests ? 'admin_directory btn on_link' : 'admin_directory btn'
            }
            onClick={() => this.setState({ requests: true, directory: false })}
          >
            View Incoming Requests
          </h4>
          <h4
            className={
              directory
                ? 'admin_directory2 btn on_link'
                : 'admin_directory2 btn'
            }
            onClick={() => {
              this.setState({ directory: true, requests: false, current: '' });
              this.getDirectory();
            }}
          >
            View All directors
          </h4>
        </div>
        {directory && (
          <div className="dir_depart">
            {this.departMap()}
          </div>
        )}
        {requests && (
          <div className="requests_dir">
            <h1>Incoming Requests</h1>

            {positions.length !== 0 && (
              <div className="director_name">
              {this.navMap()}
              </div>
            )}
            {positions.length ? (
              <div className="director_map">{this.directorMap(positions)}</div>
            ) : (
              <p className="no_entry">There are no recent entries.</p>
            )}
          </div>
        )}

        {directory && (
          <div className="requests_dir">
            <h1>Current Directory</h1>

            <div className="director_name">
            {this.navMap()}
            </div>
            <div className="director_map">{this.directorMap(all)}</div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => state;

export default connect(
  mapStateToProps,
  {
    getPositions
  }
)(Directory);



// WEBPACK FOOTER //
// ./src/Components/Directory/Directory.js